<template>
  <div class="box2-container">
    <div class="title">
      <h3>{{video.title}}</h3>
      <div class="r_block">
        <span></span>
        <em></em>
        <span></span>
      </div>
    </div>
    <div class="content">
      <div class="video" v-if="video.number">
        <video-box
            ref="video_box2"
            :video="video"
          ></video-box>
      </div>
      <div class="video" v-else><img src="@/assets/home_images/video.png" /></div>
    </div>
    <div class="bottom">
      <div class="r_block">
        <span></span>
        <em></em>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
import cameraApi from "@/api/light/camera";
import videoBox from '@/components/video/VideoBox.vue'
export default {
  name: 'Box2', 
  components: {
    videoBox
  },
  props: {
    itemData: {
      type: Object,
      required: true, // 默认值是false
      default: function () {
        return {
          number: '',
          channel: 1
        };
      },
    }
  },
  data() {
    return {
      video: {
        title: '',
        number: '',
        camera_type: 1,
        channel: 1,
        access_token: ''
      }
    }
  },
  watch: {
    itemData: {
      handler(newVal, oldVal) {
        if(newVal){
          if(newVal.number&&newVal.number!=oldVal.number){
            this.getCameraInfo()
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getCameraInfo () {
      console.log('this.itemData', this.itemData)
      if (!this.itemData.number) {
        return
      }
      cameraApi.cameraInfo({
        number: this.itemData.number,
        channel: this.itemData.channel
      }).then((res) => {
        if (res.data.code === 1000) {
          console.log('res.data.data', res.data.data)
          const {title, number, camera_type, channel, access_token} = res.data.data
          this.video = {
            title: title,
            number: number,
            camera_type: camera_type,
            channel: channel,
            access_token: access_token,
          }
        }
      });
    },
  }
}
</script>
<style lang='less'>
.box2-container {
  width: 100%;
  height: 100%;
  position: relative;
  .title {
    height:48px;
    display: flex;
    align-items: center;
    justify-content: flex-start ;
    width: 100%;
    background-image: url(../../assets/home_images/title_bg2.png);
    background-position: 0 center;
    background-repeat: no-repeat;
    position: relative;
    h3{
      font-size: 16px;
      font-weight: normal;
      color: #fff;
      padding-left: 20px;
      margin:0;
      margin-top:5px;
    }
    .r_block{
      position: absolute;
      right:0;
      bottom:9px;
      display: flex;
      align-items: center;
      span{
        width:3px;
        height:7px;
        background: #1de7ff;
        display: block;
      }
      em{
        width:12px;
        height:7px;
        background: #01162b;
        display: block;
      }
    }
  }
  .bottom{
    height:4px;
    display: flex;
    align-items: center;
    justify-content: flex-start ;
    width: 100%;
    background-image: url(../../assets/home_images/con_bot.png);
    background-position: 0 center;
    background-repeat: no-repeat;
    position: absolute;
    bottom: 0;
    left: 0;
    .r_block{
      position: absolute;
      right:0;
      bottom:0px;
      display: flex;
      align-items: center;
      span{
        width:4px;
        height:4px;
        background: #1de7ff;
        display: block;
      }
      em{
        width:10px;
        height:4px;
        background: #01162b;
        display: block;
      }
    }
  }
  .content {
    position: absolute;
    top: 48px;
    bottom: 4px;
    left: 0;
    right:0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-image: url(../../assets/home_images/con_left.png);
    background-position: 0 0;
    background-repeat: no-repeat;
    box-sizing: border-box;
    padding: 15px 20px;
    .video {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: hidden;
      display: flex;
      justify-content: center; /* 水平居中 */
      align-items: center;     /* 垂直居中 */
      text-align:center;
      img {
        width: 100%;
        height: auto;
      }
      iframe{
        margin: 0;
        padding: 0;
        border:0;
      }
    }
  }
}
</style>
